






import ObjMap from './components/ObjMap.vue';

export default {
  name: 'App',
  components: {
    ObjMap,
  },
};
